
export default (pageContext) => {
    return pageContext.locale
}
